import {ModuleFc} from '@/project'
import {updateObject} from '@/store/utils'
import {NotiState} from './type'

const initState: NotiState = {
  isTaxNotiAllowed: false,
  // isInvoiceNotiAllowed: false,
}

const module: ModuleFc<NotiState> = (ctx) => ({
  namespaced: true,
  state: {
    ...initState,
  },
  mutations: {
    update(state, payload: NotiState) {
      updateObject<NotiState>(state, payload)
    },
    clear(state) {
      updateObject(state, initState)
    },
  },
  actions: {
    async getNoti({commit, rootState}) {
      const result = await ctx.$axios({
        url: `/bizs/${rootState?.biz?.id}/noti/`,
        method: 'get',
      })
      commit('update', result.data)
    },
    async updateNoti({commit, rootState}, payload: NotiState) {
      const result = await ctx.$axios({
        url: `/bizs/${rootState?.biz?.id}/noti/`,
        method: 'patch',
        data: payload
      })
      commit('update', result.data)
    }
  },
})

export {NotiState, initState}

export default module

